import { RiskMapDangersFieldNames, StateType } from '@app-types/riskMapFields'

export const SEQUENCE_ARR: RiskMapDangersFieldNames[] = [
  RiskMapDangersFieldNames.WORK_PLACE,
  RiskMapDangersFieldNames.OBJECT,
  RiskMapDangersFieldNames.KIND,
  RiskMapDangersFieldNames.HAZARD,
  RiskMapDangersFieldNames.EVENT,
].reverse()

const getFilters = (
  values: Partial<Record<RiskMapDangersFieldNames, string | undefined>>
): StateType['relations'] => {
  const result: StateType['relations'] = {}

  SEQUENCE_ARR.forEach((fieldName, index) => {
    if (values[fieldName]) {
      result[fieldName] = values[fieldName]

      const slicedSequence = SEQUENCE_ARR.slice(index + 1)

      slicedSequence.forEach((sequence) => {
        if (values[sequence]) {
          result[sequence] = values[sequence]
        } else {
          result[sequence] = undefined
        }
      })
    }
  })

  return result
}

export default getFilters
